<template>

	<div>
		<div class="d-flex flex-row align-items-center p-2">
			<div class="icon-stack display-3 flex-shrink-0">
				<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
				<i class="fas fa-building icon-stack-1x opacity-100 color-primary-500"></i>
			</div>
			<div class="ml-3">
				<strong>
					Підрозділ
				</strong>
				<br>
				{{ this.user.department }}
			</div>
		</div>

		<div class="d-flex flex-row align-items-center p-2">
			<div class="icon-stack display-3 flex-shrink-0">
				<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
				<i class="fas fa-user icon-stack-1x opacity-100 color-primary-500"></i>
			</div>
			<div class="ml-3">
				<strong>
					Посада
				</strong>
				<br>
				{{ this.user.dolznost }}
			</div>
		</div>


		<div class="d-flex flex-row align-items-center p-2">
			<div class="icon-stack display-3 flex-shrink-0">
				<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
				<i class="fal fa-at icon-stack-1x opacity-100 color-primary-500"></i>
			</div>
			<div class="ml-3">
				<strong>
					Email
				</strong>
				<br>
				<a class="imc_a" v-bind:href="mail_href">{{ this.user.email }}</a>
			</div>
		</div>

		<div class="d-flex flex-row align-items-center p-2">
			<div class="icon-stack display-3 flex-shrink-0">
				<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
				<i class="fas fa-phone icon-stack-1x opacity-100 color-primary-500"></i>
			</div>
			<div class="ml-3">
				<strong>
					Моб.телефон
				</strong>
				<br>
				<a class="imc_a" v-bind:href="tel_href1">{{ this.user.mobile }}</a>
			</div>
		</div>


		<div class="d-flex flex-row align-items-center p-2">
			<div class="icon-stack display-3 flex-shrink-0">
				<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
				<i class="fal fa-phone icon-stack-1x opacity-100 color-primary-500"></i>
			</div>
			<div class="ml-3">
				<strong>
					Моб телефон 2
				</strong>
				<br>
				<a class="imc_a" v-bind:href="tel_href2">{{ this.user.home }}</a>
			</div>
		</div>

		<b-overlay :show="show" rounded="sm">
			<div class="d-flex flex-row align-items-center p-2">
				<div class="icon-stack display-3 flex-shrink-0">
					<i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
					<i class="fas fa-pennant icon-stack-1x opacity-100 color-primary-500"></i>
				</div>
				<div class="ml-3">
					<strong>
						Відпустка
					</strong>
					<br>
					<div>{{ vacation }}</div>
				</div>
			</div>
            
            <div class="d-flex flex-row align-items-center p-2" v-if="obj_to_null(this.cur_vacation)">
                <div class="icon-stack display-3 flex-shrink-0">
                    <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                    <i class="fas fa-pennant icon-stack-1x opacity-100 color-primary-500"></i>
                </div>
                <div class="ml-3">
                    <strong>
                        Поточна відпустка
                    </strong>
                    <br>
                    <div>
                        <span class="badge badge-warning">Відпустка на період {{ this.cur_vacation.d_from }} - {{ this.cur_vacation.d_to }}</span>
                    </div>
                </div>
            </div>
            
		</b-overlay>
  
  
  
  

	</div>

</template>
<script>
export default {
	name: "home",
	data() {
		return {
			show: false,
			user_vacation_full : null,
			user_vacation: {
				vacation: 'Запит інформації з 1С',
			},
            
            cur_vacation : null,
		}
	},

	props: {
		user: {
			type: Object,
		},
		user_id: {
			type: Number,
			default: 0,
		}
	},

	mounted() {
		this.Vacation1C();

	},
	computed: {
		mail_href() {
			return 'mailto:' + this.user.email;
		},
		tel_href1() {
			return 'tel:' + this.user.mobile;
		},
		tel_href2 () {
			return 'tel:' + this.user.home;
		},
		vacation() {
			if(this.user_vacation_full == null) {
				return "Запит інформації з 1С";
			}
			if(this.user_vacation_full.hasOwnProperty('vacation_main_left')) {
				return "Основна " + this.user_vacation_full.vacation_main_left +" дн. Додаткова " + this.user_vacation_full.vacation_adv_left  +" дн.";
			}

			return '' + this.user_vacation.vacation;
		},
	},

	methods: {
		async Vacation1C() {
			this.show = true;
			await api.get('/user/'+ this.user_id +'/vacation').then(({data}) => {
				this.show = false;
				if (data.status === "operation_success") {
					this.user_vacation_full = data.data;
                    this.cur_vacation = data.message
				}
			}).catch(err => {
				this.user.vacation = 'Дані не доступні';
			}).finally(() => {
				this.show = false;
			});
		},
	}


}
</script>

<style scope>
.name_at {
	font-family: Roboto Bold;
	font-weight: bolder;
}


.imc_a {
	font-size: 1rem;
}
</style>
